import "./SideAudioPlayer.css"
import React, { Component } from 'react'
import {Icon} from "office-ui-fabric-react/lib/Icon";

export default class SideAudioPlayer extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            isPlaying: false,
            SongTitleTranslate: 0,
            currentSongIndex: 0,
            songTitle: props.songs[0].name
        }

        this.drift.bind(this);
        this.play.bind(this);
        this.pause.bind(this);
        this.stop.bind(this);
        this.stopDrift.bind(this);
        this.next.bind(this);
        this.prev.bind(this);

        this.interval = null;

        this.audio = new Audio(props.songs[0].audio);

    }

    drift()
    {
        var that = this;
        this.interval = setInterval(function(){
            if (that.audio.ended){
                that.next();
            }
            that.setState({
                isPlaying: that.state.isPlaying,
                SongTitleTranslate: (that.state.SongTitleTranslate === 170) ? that.state.SongTitleTranslate = -170 : that.state.SongTitleTranslate += 1
            })
        }, 1000/10);
    }

    stopDrift()
    {
        clearInterval(this.interval);
    }

    play()
    {
        this.audio.play();
        this.drift();
    }

    pause()
    {
        this.audio.pause();
        this.stopDrift();
    }

    stop()
    {
        this.audio.load();
        this.setState({
            isPlaying:false,
            SongTitleTranslate: 0
        }); 
        this.stopDrift();

    }

    next(){
        var that = this;


        function callback(){
            this.audio.setAttribute("src", that.props.songs[that.state.currentSongIndex].audio);
            this.audio.load();
            this.audio.play();
        }

        if(this.state.currentSongIndex === this.props.songs.length - 1){
            this.setState({
                isPlaying: true,
                currentSongIndex: 0,
                SongTitleTranslate: 0,
                songTitle: that.props.songs[0].name
            }, callback)
        }
        else {
            
            this.setState({
                isPlaying: true,
                currentSongIndex: that.state.currentSongIndex + 1,
                SongTitleTranslate: 0,
                songTitle: that.props.songs[that.state.currentSongIndex + 1].name
            }, callback)
        }
    

    }

    prev(){
        var that = this;

        function callback(){
            this.audio.setAttribute("src", that.props.songs[that.state.currentSongIndex].audio);
            this.audio.load();
            this.audio.play();
        }

        if(this.state.currentSongIndex === 0){
            this.setState({
                isPlaying: true,
                currentSongIndex: that.props.songs.length - 1,
                SongTitleTranslate: 0,
                songTitle: that.props.songs[that.props.songs.length - 1].name
            }, callback)
        }
        else {
            this.setState({
                isPlaying: true,
                currentSongIndex: that.state.currentSongIndex - 1,
                SongTitleTranslate: 0, 
                songTitle: that.props.songs[that.state.currentSongIndex - 1].name
            }, callback)
        }

    }

    componentWillUnmount()
    {
        clearInterval(this.interval);
    }


    
    render() {
        var that = this;

        var symbol = (!this.state.isPlaying) ? (<Icon iconName = "Play"/>) : (<Icon iconName = "Pause"/>);
        return (
            <div className = "sideAudioPlayer">
                <div className = "sideAudioPlayer-Song-container">
                    <div className = "sideAudioPlayer-Song"
                    style = {{
                        left: that.state.SongTitleTranslate.toString() + "px"
                    }}>
                        {this.state.songTitle}
                    </div>
                </div>
                <div className = "sideAudioPlayer-Icon"
                    onClick = {() => {
                        that.prev();
                    }}>
                    <Icon iconName = {"DoubleChevronLeft12"}/>
                </div>
                <div className = "sideAudioPlayer-Icon"
                    onClick = {() => {
                        that.stop();
                    }}>
                    <Icon iconName = {"Stop"}/>
                </div>
                <div className = "sideAudioPlayer-Icon"
                    onClick = {() => {
                        that.next();
                    }}>
                    <Icon iconName = {"DoubleChevronRight12"}/>
                </div>
                <div className = "sideAudioPlayer-Icon"
                    onClick = {() =>{
                        that.setState({
                            isPlaying: !that.state.isPlaying
                        });

                        (that.state.isPlaying) ? that.pause() : that.play();
                    }}>
                    {symbol}  
                </div>
            </div>
        )
    }
}
